import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Star, Quote } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [
    {
        id: 1,
        name: "Sarah Johnson",
        role: "CEO, TechCorp",
        company: "TechCorp",
        content: "Working with this team was an absolute pleasure. They delivered our e-commerce platform ahead of schedule and it's performing brilliantly.",
        rating: 5,
        avatar: "/avatar-1.jpg",
    },
    {
        id: 2,
        name: "Michael Chen",
        role: "Founder, StartupXYZ",
        company: "StartupXYZ",
        content: "The mobile app they built for us has received incredible user feedback. The attention to detail and user experience is outstanding.",
        rating: 5,
        avatar: "/avatar-2.jpg",
    },
    {
        id: 3,
        name: "Emily Rodriguez",
        role: "Marketing Director, BigBrand",
        company: "BigBrand",
        content: "Our website redesign resulted in a 150% increase in conversions. Their understanding of both design and business goals is impressive.",
        rating: 5,
        avatar: "/avatar-3.jpg",
    },
    {
        id: 4,
        name: "David Kim",
        role: "CTO, Enterprise Inc",
        company: "Enterprise Inc",
        content: "The cloud migration was seamless. Zero downtime and improved performance by 300%. Highly recommended for enterprise projects.",
        rating: 5,
        avatar: "/avatar-4.jpg",
    },
];
export function Testimonials({ showHeader = true }) {
    return (_jsx("section", { className: "section-padding bg-muted/30", children: _jsxs("div", { className: "container-page", children: [showHeader && (_jsxs("div", { className: "mx-auto max-w-2xl text-center", children: [_jsx("h2", { className: "text-3xl font-bold tracking-tight sm:text-4xl", children: "What our clients say" }), _jsx("p", { className: "mt-4 text-lg text-muted-foreground", children: "Don't just take our word for it. Here's what our clients have to say." })] })), _jsx("div", { className: "mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4", children: testimonials.map((testimonial) => (_jsx(Card, { className: "relative overflow-hidden", children: _jsxs(CardContent, { className: "p-6", children: [_jsx(Quote, { className: "absolute right-4 top-4 h-8 w-8 text-muted/50" }), _jsx("div", { className: "mb-4 flex gap-1", children: Array.from({ length: testimonial.rating }).map((_, i) => (_jsx(Star, { className: "h-4 w-4 fill-warning text-warning" }, i))) }), _jsxs("p", { className: "text-sm leading-relaxed text-muted-foreground", children: ["\"", testimonial.content, "\""] }), _jsxs("div", { className: "mt-6 flex items-center gap-3", children: [_jsxs(Avatar, { className: "h-10 w-10", children: [_jsx(AvatarImage, { src: testimonial.avatar, alt: testimonial.name }), _jsx(AvatarFallback, { children: testimonial.name
                                                        .split(" ")
                                                        .map((n) => n[0])
                                                        .join("") })] }), _jsxs("div", { children: [_jsx("p", { className: "text-sm font-medium", children: testimonial.name }), _jsx("p", { className: "text-xs text-muted-foreground", children: testimonial.role })] })] })] }) }, testimonial.id))) })] }) }));
}
